import React from 'react';
import Image1 from '../assets/logo/Image 1.png'
import Image2 from '../assets/logo/Image 2.png'
import Image3 from '../assets/logo/Image 3.png'
import Image4 from '../assets/logo/Image 4.png'
import Image5 from '../assets/logo/Image 5.png'
// import Image6 from '../assets/logo/Image 6.png' 
import Image7 from '../assets/logo/Image 7.png'
import Image8 from '../assets/logo/Image 8.png'
import Image9 from '../assets/logo/Image 9.png'
import Image10 from '../assets/logo/Image 10.png'
import Image11 from '../assets/logo/Image 11.png'
import Image12 from '../assets/logo/Image 12.png'
import Image13 from '../assets/logo/Image 13.png'
import Image14 from '../assets/logo/Image 14.png'
import Image15 from '../assets/logo/Image 15.png'
import Image16 from '../assets/logo/Image 16.png'
import Image17 from '../assets/logo/Image 17.png'
import Image18 from '../assets/logo/Image 18.png'
import Image19 from '../assets/logo/Nigeria.png'
import Image20 from '../assets/logo/Hilary.png'
import Image21 from '../assets/logo/Trucrete.png'


const Client = () => {

  return (
    <div className='flex justify-center space-x-[56px] mr-[56px]'>
            <img src={Image1} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image2} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image3} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image4} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image5} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image7} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image8} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image9} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image10} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image11} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image12} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image13} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image14} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image15} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image16} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image17} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image18} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            <img src={Image19} alt='' className='lg:w-20 lg:h-16 w-20 h-20'></img>
            
           
    </div>
  )
}

export default Client;